import { TeamPlanStatusDto, TeamPlanStatusFilterDto } from '@/api/generated';
import { AreaTranslation } from '@/assets/locales/views/area/area.translation.en.ts';

export const areaTranslation: AreaTranslation = {
  alerts: {
    count_few: '{{count}} alerty',
    count_many: '{{count}} alertów',
    count_one: '{{count}} alert',
    empty: 'Brak zdarzeń wymagających uwagi w Twoim obszarze.',
    items: {
      absenceReturns: {
        subtitle: 'Powroty z długotrwałej absencji — warto zaplanować rozmowę powrotną',
        title: '{{value}} powrotów z absencji',
      },
      birthdays: {
        subtitle: 'Nadchodzące urodziny w podległym obszarze',
        title: '{{value}} urodzin',
      },
      endingContracts: {
        subtitle: 'Umowy kończące się w ciągu najbliższych 14 dni',
        title: '{{value}} kończących się umów',
      },
      headcount: {
        subtitle: 'Zmiana {{delta}} wobec stanu sprzed 2 tygodni',
        title: 'Stan zatrudnienia: {{value}}',
      },
      overdueSteps: {
        subtitle: 'Termin kroku minął, a krok nie został ukończony w aktywnym cyklu',
        title: '{{value}} pracowników z zaległymi krokami',
      },
      plansToApprove: {
        subtitle: 'Plany gotowe do realizacji, czekające na akceptację przełożonego',
        title: '{{value}} planów do akceptacji',
      },
      withoutPlan: {
        subtitle: 'Brak planu rozwoju w bieżącym cyklu',
        title: '{{value}} pracowników bez planu rozwoju',
      },
    },
    title: 'Wymagające uwagi HRBP',
  },
  kpi: {
    employees: 'Pracowników w obszarze',
    openSuccessions: 'Otwarte sukcesje',
    overdueSteps: 'Zaległe kroki',
    plansToApprove: 'Plany do akceptacji',
    withoutPlan: 'Bez planu rozwoju',
  },
  people: {
    badges: {
      contractEnding: 'Koniec umowy (poniżej 35 dni)',
      longAbsence: 'Długa absencja',
      panels: 'Panele dyskusyjne',
      pendingPanel: 'Brak uzupełnionych wniosków z panelu',
      trainings: 'Ukończone aktywności',
    },
    count: '{{shown}} z {{total}} pracowników',
    empty: 'Brak wyników',
    filters: {
      planStatus: {
        [TeamPlanStatusFilterDto.All]: 'Wszystkie',
        [TeamPlanStatusFilterDto.Approved]: 'Zatwierdzony',
        [TeamPlanStatusFilterDto.None]: 'Brak planu',
        [TeamPlanStatusFilterDto.Overdue]: 'Zaległy',
        [TeamPlanStatusFilterDto.Waiting]: 'Czeka',
      },
      planStatusAll: 'Dowolny status planu',
      planStatusLabel: 'Status planu',
      risk: {
        all: 'Wszystkie',
        high: 'Wysokie',
        low: 'Niskie',
        medium: 'Średnie',
      },
      riskAll: 'Dowolne ryzyko odejścia',
      riskLabel: 'Ryzyko odejścia',
      trainingsAll: 'Dowolna aktywność',
      trainingsLabel: 'Aktywności',
    },
    headers: {
      department: 'Dział / Lokalizacja',
      employee: 'Pracownik',
      plan: 'Plan%',
      pmc: 'PMC',
      risk: 'Ryzyko odejścia',
      sop: 'SOP',
      status: 'Status planu',
      succession: 'Sukcesja',
    },
    panelDialog: {
      cancel: 'Anuluj',
      date: 'Data panelu',
      feedback: 'Feedback / Rekomendacje',
      feedbackPlaceholder: 'Wpisz wnioski z panelu...',
      role: 'Rozważane stanowisko',
      rolePlaceholder: 'np. Lider Zespołu',
      save: 'Zapisz wnioski',
      title: 'Wprowadź feedback z panelu',
    },
    planStatus: {
      [TeamPlanStatusDto.Approved]: 'Zatwierdzony',
      [TeamPlanStatusDto.Draft]: 'Roboczy',
      [TeamPlanStatusDto.None]: 'Brak planu',
      [TeamPlanStatusDto.Overdue]: 'Zaległy',
      [TeamPlanStatusDto.Waiting]: 'Czeka',
    },
    searchPlaceholder: 'Szukaj pracownika...',
  },
  pipeline: {
    buckets: {
      from1To2Years: 'Średni horyzont (1–2 lata)',
      from3To5Years: 'Długi horyzont (3–5 lat)',
      readyNow: 'Gotowi teraz (0 mies.)',
      upTo1Year: 'Krótki horyzont (do 1 roku)',
    },
    title: 'Gotowość do awansu (Pipeline)',
    total: 'Łącznie w pipeline',
    totalValue: '{{value}} pracowników',
  },
  pmc: {
    average: 'Średnia PMC obszaru',
    title: 'Rozkład ocen PMC',
  },
  risk: {
    chips: {
      risk: {
        high: 'Wysokie',
        low: 'Niskie',
        medium: 'Średnie',
      },
      succession: {
        dev: 'W rozwoju',
        none: 'Brak',
        ready: 'Gotowy/a',
      },
    },
    peopleCount: '{{count}} osób',
    riskTitle: 'Ryzyko odejścia',
  },
  stats: {
    backToStart: 'Wróć na Start',
    sectionTitle: 'Potencjał i ryzyko obszaru',
  },
  succession: {
    meta: {
      candidates: '{{count}} kandydatów',
      emptyForMonths: 'Brak kandydatów od {{count}} mies.',
    },
    needsIntervention: 'Wymaga interwencji HR.',
    positionsCount: '{{count}} stanowiska',
    readiness: {
      ready: 'Gotowa teraz',
      upTo2Years: '1–2 lata',
      upTo3Years: '2–3 lata',
    },
    state: {
      empty: 'Pipeline pusty',
      inProgress: 'W przygotowaniu',
      ready: 'Pipeline gotowy',
    },
    title: 'Sukcesja',
  },
  tabs: {
    dashboard: 'Dashboard HRBP',
    matrix: 'Macierz zespołu',
    people: 'Pracownicy',
    peopleWithCount: 'Pracownicy ({{value}})',
    risk: 'Ryzyko i Sukcesja',
  },
};
